export enum InsuranceType {
    ExpenseProtector = 0,
    PersonalAccident = 1
}
